import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { InputComponent } from "@components/input/input.component";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-fritext-filter",
    templateUrl: "./tpl-fritext-filter.component.html",
    styleUrls: ["./tpl-fritext-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        InputComponent
    ]
})
export class TplFritextFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {
    constructor() {
        super("fritext");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl(null));
    }

    onFilterInit(state: string): void {
        this.control.setValue(state);
    }

    match(item: ITplArbetsorder): boolean {
        const value = this.value()?.toLowerCase().trim();
        const actual1 = item.beteckning?.toLowerCase();
        const actual2 = item.namn?.toLowerCase();

        return actual1?.indexOf(value) > -1 || actual2?.indexOf(value) > -1;
    }

    value(): string {
        return this.control.value;
    }

    isActive(): boolean {
        return !!this.value();
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFormChange(value: string): void {
        this.filterLength = value ? 1 : 0;
    }
}
